import React from "react";
import LoginCard from "../components/loginCard/loginCard";

const AuthenticationPage = () => {
  return (
    <LoginCard />
  );
}

export default AuthenticationPage;